module.exports = __webpack_public_path__ + "static/media/expired-img.de3ce5ae.svg";